import React from 'react';

/**
 * Pasek krokow kreatora. Kroki przyszle sa NIEKLIKALNE - kolejnosc
 * cennik -> faktura jest calym sensem kreatora.
 *
 * krok  - numer biezacego kroku (1|2|3)
 * kroki - opcjonalna lista { numer, tytul, podpis, zrobiony }
 */
const DOMYSLNE_KROKI = [
  { numer: 1, tytul: 'Cennik dostawcy', podpis: 'nazwy i stawki VAT' },
  { numer: 2, tytul: 'Faktura XML', podpis: 'ceny zakupu i ilości' },
  { numer: 3, tytul: 'Gotowe', podpis: 'podsumowanie' }
];

const WizardStepper = ({ krok = 1, kroki = DOMYSLNE_KROKI }) => {
  const lista = (kroki && kroki.length) ? kroki : DOMYSLNE_KROKI;

  return (
    <div style={{
      display: 'flex', gap: '8px', flexWrap: 'wrap',
      marginBottom: '16px'
    }}>
      {lista.map((k) => {
        const zrobiony = k.zrobiony != null ? k.zrobiony : k.numer < krok;
        const aktywny = k.numer === krok;

        let tlo = 'var(--card-bg)';
        let kolorTekstu = 'var(--text-muted)';
        let ramka = '1px solid var(--border)';

        if (aktywny) {
          tlo = 'var(--primary)';
          kolorTekstu = '#fff';
          ramka = '1px solid var(--primary)';
        } else if (zrobiony) {
          tlo = 'var(--success)';
          kolorTekstu = '#fff';
          ramka = '1px solid var(--success)';
        }

        return (
          <div
            key={k.numer}
            style={{
              flex: '1 1 180px', minWidth: '160px',
              padding: '8px 12px', borderRadius: '6px',
              backgroundColor: tlo, border: ramka, color: kolorTekstu,
              cursor: 'default', userSelect: 'none'
            }}
          >
            <div style={{ fontSize: '12px', fontWeight: '600' }}>
              {zrobiony && !aktywny ? '✓' : k.numer}. {k.tytul}
            </div>
            <div style={{
              fontSize: '10px', marginTop: '2px',
              color: (aktywny || zrobiony) ? 'rgba(255,255,255,0.85)' : 'var(--text-muted)'
            }}>
              {k.podpis || ''}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default WizardStepper;
